// components/NotificationBadge/NotificationBadge.jsx
import React from "react";
import { useSelector } from "react-redux";
import "./NotificationBadge.scss";

const NotificationBadge = ({ notificationKey, children, maxCount = 99 }) => {
  const count = useSelector(
    (state) => state.notifications.counts[notificationKey] || 0
  );

  const displayCount = count > maxCount ? `${maxCount}+` : count;

  return (
    <div className="notification-badge-container">
      {children}
      {count > 0 && <span className="notification-badge">{displayCount}</span>}
    </div>
  );
};

export default NotificationBadge;
